// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1K1Tu","vLegacy":"SelectSecondary_vLegacy__2UUpZ","error":"SelectSecondary_error__3Mvvg","disabled":"SelectSecondary_disabled__1FGkE"};